import { ApiRequestFilters } from '../../../shared/types/api-request-filters';

/**
 * Driver filters
 */
export class TenantDriversFilters extends ApiRequestFilters {}
